import * as React from "react";
import Layout from "@app/Layout.tsx";
import { Container } from "react-bootstrap";
import Canonical from "@shared/head/Canonical";
import Breadcrumbs from "@shared/head/Breadcrumbs";
import Price from "@features/Price/";
import FAQ from "@widgets/FAQ";
import questions from "@features/Price/questionsEn.json";
import calculator from "@features/Price/calculatorEn.json";

// SEO Meta
export const Head = () => (
  <>
    <title>Pricing & Plans — Dashly AI Inbound Revenue Agents</title>
    <meta name="description" content="Choose a plan based on traffic volume, active leads, and integrations. Free trial available. ROI payback in 2-5 months." />
    <meta property="og:image" content="https://www.dashly.io/cover/en/pricing.png" />
    <Canonical url="https://www.dashly.io/pricing/" />
    <Breadcrumbs
      list={[
        { name: "Dashly", url: "https://www.dashly.io/" },
        {
          name: "Dashly - Pricing - $24 for Business chat",
          url: "https://www.dashly.io/pricing/",
        },
      ]}
    />
  </>
);

const dashlyPrice = (props) => {
  return (
    <Layout className="page page-price page-price-en">
      <div className="px-0 px-lg-3">
        <Price calculator={calculator} />
      </div>

      <Container />

      <FAQ title="FAQ" items={questions} />
    </Layout>
  );
};

export default dashlyPrice;
